import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/images/logobg.png'
import _imports_1 from '../assets/images/logo1.png'


const _hoisted_1 = { class: "signupPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logobg" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Logezy Reference"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "login-section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Logezy Reference ")
], -1)
const _hoisted_5 = { class: "login-form" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Agency "),
  /*#__PURE__*/_createElementVNode("span", null, "Registration")
], -1)
const _hoisted_7 = { class: "midSec" }
const _hoisted_8 = { class: "midSec" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Register ")
const _hoisted_10 = { class: "register" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 12,
          class: "left"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 12,
          class: "right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_a_form, {
                  ref: "formRef",
                  model: _ctx.formState,
                  rules: _ctx.rules,
                  layout: "vertical",
                  onFinish: _ctx.register,
                  onFinishFailed: _ctx.handleFinishFailed,
                  "label-col": _ctx.labelCol,
                  "wrapper-col": _ctx.wrapperCol
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      ref: "agency_name",
                      required: "",
                      label: "Agency Name",
                      name: "agency_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formState.agency_name,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.agency_name) = $event)),
                          placeholder: "Enter agency name",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 512),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, {
                        ref: "first_name",
                        required: "",
                        label: "First Name",
                        name: "first_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formState.first_name,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.first_name) = $event)),
                            placeholder: "Enter first name",
                            "allow-clear": "",
                            autocomplete: "off"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_a_form_item, {
                        ref: "last_name",
                        required: "",
                        label: "Last Name",
                        name: "last_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formState.last_name,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.last_name) = $event)),
                            placeholder: "Enter last name",
                            "allow-clear": "",
                            autocomplete: "off"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_a_form_item, {
                        ref: "email",
                        required: "",
                        label: "Email",
                        name: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            placeholder: "Email",
                            value: _ctx.formState.email,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.email) = $event)),
                            type: "text",
                            "allow-clear": "",
                            autocomplete: "off"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_a_form_item, {
                        ref: "phone",
                        required: "",
                        label: "Phone Number",
                        name: "phone"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formState.phone,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.phone) = $event)),
                            placeholder: "Phone Number",
                            "allow-clear": "",
                            autocomplete: "off"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _createVNode(_component_a_form_item, {
                      ref: "address1",
                      required: "",
                      label: "Address Line1",
                      name: "address1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formState.address1,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.address1) = $event)),
                          placeholder: "Enter Address1",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(_component_a_form_item, {
                      ref: "address2",
                      label: "Address Line2",
                      name: "address2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formState.address2,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.address2) = $event)),
                          placeholder: "Enter Address2",
                          "allow-clear": "",
                          autocomplete: "off"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 512),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        ref: "city",
                        required: "",
                        label: "City",
                        name: "city"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formState.city,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.city) = $event)),
                            placeholder: "City ",
                            "allow-clear": "",
                            autocomplete: "off"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_a_form_item, {
                        ref: "postal_code",
                        required: "",
                        label: "Postcode ",
                        name: "postal_code"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formState.postal_code,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.postal_code) = $event)),
                            placeholder: "Postcode",
                            "allow-clear": "",
                            autocomplete: "off"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _createVNode(_component_a_form_item, {
                      ref: "country",
                      label: "Country",
                      required: "",
                      name: "country"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.formState.country,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.country) = $event)),
                          placeholder: "Select Country",
                          "show-search": "",
                          "filter-option": _ctx.filterOption
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCountries, (country) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                value: country.name,
                                key: country.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(country.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "filter-option"])
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          size: "large",
                          block: "",
                          class: "login-btn",
                          "html-type": "submit",
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules", "onFinish", "onFinishFailed", "label-col", "wrapper-col"]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, [
                    _createVNode(_component_router_link, { to: "/login" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}